/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { icons } from "src/environments/config";
import { SlotService } from "src/app/services/slot/slot.service";

@Component({
  selector: "app-size-quantity",
  templateUrl: "./size-quantity.component.html",
  styleUrls: ["./size-quantity.component.scss"],
})
export class SizeQuantityComponent implements OnInit {
  @Input() item;
  @Input() val;
  @Input() isPriceDisplay;
  @Input() isWishList;
  @Input() isCart;

  @Output() updateQuantity: EventEmitter<any> = new EventEmitter();
  value: number = 0;
  blueFavourite = icons.liveshopIcon.blueFavourite;
  blackFavourite = icons.liveshopIcon.blackFavourite;
  constructor(public slotService: SlotService) {}

  ngOnInit(): void {
    this.value = <number>this.val;
    if (this.isCart && this.slotService.cart && this.slotService.cart.length) {
      const index = this.slotService.cart.findIndex(
        (eachProduct) => eachProduct.inventory._id === this.item._id
      );
      if (index !== -1) {
        this.value = this.slotService.cart[index].numberOfUnits;
      }
    }
  }

  decreaseQuantity = () => {
    if (this.value !== 0) {
      this.value--;
      this.updateQuantity.emit({ id: this.item._id, value: this.value });
    }
  };

  increaseQuantity = () => {
    // if(this.value!==this.item.numberOfUnits)
    // {
    this.value++;
    this.updateQuantity.emit({ id: this.item._id, value: this.value });
    // }
  };
}
